import { z } from 'zod';
import { parseAmountText } from './amount-text.js';

/** Model strings use the same grammar as source-proven planner fields. */
export const moneyAmountSchema = z.preprocess(
  (value) => (typeof value === 'string' ? (parseAmountText(value) ?? value) : value),
  z
    .number()
    .finite()
    .nonnegative()
    .max(Number.MAX_SAFE_INTEGER)
    .refine((value) => Number(value.toFixed(2)) === value, 'Money has at most two decimal places'),
);
